// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EmailView_wrapper__39zIs","container":"EmailView_container__gnpnL","avatar":"EmailView_avatar__20PaD"};